import React, { useEffect } from "react";
import { useState } from "react";
import {
  getMultiDataComparisonData,
  resetFlow,
  resolveMultiDataComparison,
} from "../../hyperFlowSlice";
import {
  MultiDataComparationRevisionChoice,
  MultiDataComparisonData,
  MultiDataComparisonDataItem,
} from "../../hyperFlowAPI";
import {
  selectMultiDataComparisonData,
  selectMultiDataComparisonLoading,
} from "../../hyperFlowSlice";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { RadioButton } from "../../../../common/components/Btns/RadioButton";
import { ClipLoader } from "react-spinners";

export interface MultiDataComparisonComponentProps {
  execFlowId: string;
  stepId: string;
  isCurrentStep: boolean;
}

export const MultiDataComparisonComponent: React.FC<
  MultiDataComparisonComponentProps
> = ({ execFlowId, stepId, isCurrentStep }) => {
  console.log("Rendering MultiDataComparisonComponent", { execFlowId, stepId });
  const dispatch = useAppDispatch();

  const data = useAppSelector(selectMultiDataComparisonData);
  const loading = useAppSelector(selectMultiDataComparisonLoading);
  const confirmed = useAppSelector(
    (state) => state.hyperFlow.multiDataComparisonSubState.confirmed,
  );

  useEffect(() => {
    if (execFlowId && stepId) {
      console.log("Fetching multi data comparison data", {
        execFlowId,
        stepId,
      });
      dispatch(getMultiDataComparisonData({ execFlowId, stepId }));
    }
  }, [dispatch, execFlowId, stepId]);

  useEffect(() => {
    if (confirmed) {
      dispatch(resetFlow());
    }
  }, [confirmed]);

  const [selectedChoiceId, setSelectedChoiceId] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const getChoiceId = (choice: MultiDataComparationRevisionChoice) => {
    return choice.stepId;
  };

  const getTypeName = (type: string) => {
    switch (type) {
      case "EQUALS":
        return "Igual a";
      case "EQUALS_IGNORE_CASE":
        return "Igual a (ignorar mayúsculas)";
      case "NOT_EQUALS":
        return "No igual a";
      case "GREATER_THAN":
        return "Mayor que";
      case "LESS_THAN":
        return "Menor que";
      default:
        return type;
    }
  };

  const getChoiceLabel = (choice: any) => {
    return (
      choice.name ||
      choice.label ||
      choice.title ||
      choice.description ||
      String(choice.nextStepId || choice.id || choice.value || " choice")
    );
  };

  const confirmNextStep = async () => {
    if (!selectedChoiceId) return;
    try {
      setSubmitting(true);
      // dispatch resolve and then reload
      // selectedChoiceId may be a stringified object; attempt to use as-is
      await dispatch(
        resolveMultiDataComparison({
          execFlowId,
          stepId,
          selectedDataId: selectedChoiceId,
        }) as any,
      );
      await dispatch(getMultiDataComparisonData({ execFlowId, stepId }) as any);
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };
  const [activeTab, setActiveTab] = useState<"items" | "choices">("items");

  if (loading === "pending") {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <ClipLoader color="white" size="150px" />
      </div>
    );
  }

  return (
    <div style={{ color: "white", width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          overflow: "hidden",
        }}
      ></div>

      <div style={{ marginTop: 12 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            alignContent: "center",
            justifyContent: "center",
            gap: 8,
            marginBottom: 12,
          }}
        >
          <button
            onClick={() => setActiveTab("items")}
            style={{
              padding: "8px 12px",
              background: activeTab === "items" ? "#1A617D" : "transparent",
              color: activeTab === "items" ? "white" : "#ddd",
              border: "none",
              borderRadius: 6,
            }}
          >
            Items
          </button>
          {isCurrentStep && (
            <button
              onClick={() => setActiveTab("choices")}
              style={{
                padding: "8px 12px",
                background: activeTab === "choices" ? "#1A617D" : "transparent",
                color: activeTab === "choices" ? "white" : "#ddd",
                border: "none",
                borderRadius: 6,
              }}
            >
              Seleccionar acción
            </button>
          )}
        </div>

        {activeTab === "items" ? (
          <div style={{ padding: "8px", overflow: "auto", height: "100%" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th
                    style={{
                      textAlign: "left",
                      padding: 8,
                      border: "1px solid rgba(255,255,255,0.12)",
                    }}
                  >
                    Campo
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: 8,
                      border: "1px solid rgba(255,255,255,0.12)",
                    }}
                  >
                    Descripción
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: 8,
                      border: "1px solid rgba(255,255,255,0.12)",
                    }}
                  >
                    Dato A
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: 8,
                      border: "1px solid rgba(255,255,255,0.12)",
                    }}
                  >
                    Tipo
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: 8,
                      border: "1px solid rgba(255,255,255,0.12)",
                    }}
                  >
                    Dato B
                  </th>
                  <th
                    style={{
                      textAlign: "left",
                      padding: 8,
                      border: "1px solid rgba(255,255,255,0.12)",
                    }}
                  >
                    Resultado
                  </th>
                </tr>
              </thead>
              <tbody>
                {data && data.items.length > 0 ? (
                  data.items.map((item: MultiDataComparisonDataItem) => (
                    <tr key={item.comparisonId} style={{ fontSize: "13px" }}>
                      <td
                        style={{
                          padding: 8,
                          border: "1px solid rgba(255,255,255,0.12)",
                        }}
                      >
                        {item.fieldName}
                      </td>
                       <td
                        style={{
                          padding: 8,
                          border: "1px solid rgba(255,255,255,0.12)",
                        }}
                      >
                        {item.description}
                      </td>
                      <td
                        style={{
                          padding: 8,
                          border: "1px solid rgba(255,255,255,0.12)",
                        }}
                      >
                        {item.dataA}
                      </td>
                      <td
                        style={{
                          padding: 8,
                          border: "1px solid rgba(255,255,255,0.12)",
                        }}
                      >
                        {getTypeName(item.comparisonType)}
                      </td>
                      <td
                        style={{
                          padding: 8,
                          border: "1px solid rgba(255,255,255,0.12)",
                        }}
                      >
                        {item.dataB}
                      </td>
                      <td
                        style={{
                          padding: 8,
                          border: "1px solid rgba(255,255,255,0.12)",
                        }}
                      >
                        {item.result ? "✅" : "❌"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      style={{
                        padding: 8,
                        border: "1px solid rgba(255,255,255,0.12)",
                      }}
                    >
                      No hay comparaciones disponibles
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
              {data?.choices && data.choices.length > 0 ? (
                data.choices.map((choice: any, idx: number) => {
                  const cid = getChoiceId(choice);
                  return (
                    <div
                      key={cid + idx}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <RadioButton
                        label={getChoiceLabel(choice)}
                        checked={selectedChoiceId === String(cid)}
                        onChange={(_e: any, _checked: boolean) =>
                          setSelectedChoiceId(String(cid))
                        }
                        onClick={() => setSelectedChoiceId(String(cid))}
                      />
                    </div>
                  );
                })
              ) : (
                <div>No hay opciones disponibles</div>
              )}
            </div>

            <div style={{ marginTop: 12 }}>
              <button
                onClick={confirmNextStep}
                disabled={!selectedChoiceId || submitting}
                style={{
                  marginTop: "auto",
                  marginRight: "2%",
                  marginLeft: "auto",
                  background: "rgba(0,0,0,0.4)",
                  paddingRight: "8%",
                  paddingTop: "10px",
                  paddingBottom: "10px",
                  paddingLeft: "8%",
                  borderRadius: "8px",
                  textAlign: "center",
                  border: "none",
                  color: "#FFFFFF",
                }}
              >
                {submitting ? "Enviando..." : "Confirmar siguiente paso"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiDataComparisonComponent;
